import ReactOnRails from 'react-on-rails/client';
import IncidentsLog from '../../app/IncidentsLog.jsx';

ReactOnRails.register({IncidentsLog});